module.exports = __webpack_public_path__ + "static/logo_expose.cc3a46e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/logo_expose.png
// module id = 578
// module chunks = 37581630142331